import { Map as map } from 'immutable';
const C = require("../constants");

function OpenTableReducer(state = map(), action) {
    switch (action.type) {
        case C.SALES_OPEN_TABLE:
            return { data: action.data};
        default:
            return state;
    }
}

export default OpenTableReducer;


// WEBPACK FOOTER //
// ./src/reducers/OpenTableReducer.js